import React from "react";
import { useDebouncedValue } from "@tanstack/react-pacer";

import { Input } from "./input";

// A typical debounced input react component
export function DebouncedInput({
	value: initialValue,
	onChange,
	wait = 500,
	...props
}: {
	value: string | number;
	onChange: (value: string | number) => void;
	wait?: number;
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, "onChange">) {
	const [value, setValue] = React.useState(initialValue);
	const [debouncedValue] = useDebouncedValue(value, {
		wait,
	});

	React.useEffect(() => {
		onChange(debouncedValue);
	}, [debouncedValue]);

	return (
		<Input
			{...props}
			value={value}
			onChange={(e) => setValue(e.target.value)}
		/>
	);
}
